import { render } from "./QuestionEdit.vue?vue&type=template&id=587102a8"
import script from "./QuestionEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/question/QuestionEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "587102a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('587102a8', __exports__)) {
    api.reload('587102a8', __exports__)
  }
  
  module.hot.accept("./QuestionEdit.vue?vue&type=template&id=587102a8", () => {
    api.rerender('587102a8', render)
  })

}


export default __exports__